import Vue from "vue";
import VueI18n from "vue-i18n";
import vConsole from "vconsole";
import { ingame, dataURLtoFile, getSys, download, isMobile } from '@tencent/pa-cms-utils';
import Aegis from 'aegis-web-sdk';

import { getRoleInfo, saveRoleInfo, RoleInfo, getLoginedInitInfo, submitShare } from "@/api/modules/page";
import { IsTest, getLang, switchLang, isInIntlBrowser, getSpecialBrowserType, domToBase64, imageToBase64 } from "@/utils/tools";
import { initServetime } from "@/api";
import { reportTlog } from "@/api/modules/report";
import { fb_app_id, ProdServerMap, isHtm, game_id, htmUrl } from "@/utils/const";
import { dynamicShare, share } from "@/utils/share";
import Login, { checkLogin } from "@/utils/login";
import './style.css'
import { setLanguageDialog, languageArr, closeLangDialog } from './utils/setLanguage'

Vue.use(VueI18n)
Vue.config.productionTip = false;
if (IsTest) {
  new vConsole();
}
const AegisIdMap = {
  "29157" : "zYWLZizDj7RG9d6aoR", 
  "29080": "dWmboSvoOJ09Wa7ZwW",
}
const AegisId = AegisIdMap[game_id];
if (!AegisId) {
  console.error("AegisId not found", game_id);
}
new Aegis({
  id: AegisId, // 上报 id
  uin: Login.info()?.openid, // 用户唯一 ID（可选）
  reportApiSpeed: true, // 接口测速
  reportAssetSpeed: true, // 静态资源测速
  spa: true, // spa 应用页面跳转的时候开启 pv 计算
  hostUrl: 'https://rumt-sg.com',
  env: IsTest ? "test" : "production",
  api: {
    apiDetail: true,
  },
});
reportTlog({
  action: "nikkebunny_home_page",
  sub_action: "cm_vshow"
});
(window as any).reportTlog = reportTlog;
const DEFAULT_LANG = "en";

const CMSLanguage = {
  en : 'en',
  th : 'th',
  fr : 'fr',
  de : 'de',
  pt : 'pt-all',
  es : 'es',
  id : 'id',
  ja : 'ja',
  ko : 'ko',
}
// 语言路径
const allLanguageContext= require.context('./locales', false, /\**\.js$/);
const locales = allLanguageContext.keys().reduce((pre, fileName) => {
  const componentConfig = allLanguageContext(fileName)
  const name = fileName.replace(".js", "").replace("./", "");
  return {
    ...pre,
    [name]: componentConfig.default,
  }
}, {})
export const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales,
  fallbackLocale: DEFAULT_LANG,
});
const LOCALE_KEY = "localeLanguage";

const getLangFromStorage = () => {
  const storeLang = window.localStorage.getItem(LOCALE_KEY);
  if (!storeLang) return;
  const lang = locales[storeLang as keyof typeof locales]
  if (lang === undefined) return;
  return storeLang;
}
export const setLocal = (language?: string|null) => {
  console.log("setLocal", language);
  let lang = language;
  if (lang === undefined || lang === null) {
    lang = getLangFromStorage();
  }
  if (!lang) return;
  window.localStorage.setItem(LOCALE_KEY, lang);
  i18n.locale = lang;
};
const urlLangType = getLang();
window.setLocal = setLocal;
setLocal(urlLangType);
(window as any).language = urlLangType?.toUpperCase();
const init = Vue.prototype._init;
Vue.prototype._init = function (options: any) {
  init.call(this, {
    i18n,
    ...options,
  });
};

// TODO test
const startTimestamp= 1717617599; // 2024-06-06 04:59:59(utc+9)
const endTimestap= 1718827199; // 2024-06-20 04:59:59(utc+9)
// const startTimestamp= (new Date().getTime() - 1000 * 60)/1000;
// const endTimestap= (new Date().getTime() + 1000 * 60)/1000;
const dynamicPath = '_20240606_01'

new Vue<any>({
  el: "#app",
  data() {
    return {
      languageArr,
      language: urlLangType,

      roleId: 0,
      areaId: 0,
      selectedRoleId: 0,

      roleList: [],
      selectedRoleList: [],
      isLogin: checkLogin(),
      choosed: false,
      serverList: ProdServerMap,
      loading: false,
      
      isInIntlBrowser,
      isHtm,

      showMask: false,

      shareImgs: [],
      isInit: false, // 是否初始化， 只有在发送请求前才会触发登录
      shareLoading: 0,
      firstBinding: false,

      dynamicShareResult:null,
      kakaoShareResult: null,
    }
  },
  computed: {
    languageText(){
      const lang = languageArr.find(lang =>lang.value === this.language)
      if (!lang) {
        const english = languageArr.find(lang =>lang.value === 'en')
        return english?.label
      }
      return lang.label;
    },
    roleName() {
      if (!this.isLogin) return ' ';
      if (!this.roleId) return '';
      const role = this.roleList.find((role: RoleInfo) => role.role_id === this.roleId);
      if (!role) return '';
      return role.role_name;
    },
    selectedName() {
      if (!this.isLogin) return ' ';
      if (!this.selectedRoleId || !this.choosed) return '';
      const role = this.selectedRoleList.find((role: RoleInfo) => role.role_id === this.selectedRoleId);
      if (!role) return '';
      return role.role_name;
    },
    selectRoleName() {
      if (!this.roleName) return this.$t('please_select');
      return this.roleName;
    },
    serverName() {
      if (!this.areaId) return this.$t('please_select');
      const server = this.serverList.find((server: any) => server.id == this.areaId);
      if (!server) return this.$t('please_select');
      return server.name;
    },
    showNv() {
      if (this.language === 'ko') return 'naver';
      if (isHtm || this.language === 'th') return 'facebook';
      return 'twitter';
    },
    showKakao() {
      const browser = getSpecialBrowserType();
      return !isInIntlBrowser && !['facebook', 'twitter'].includes(browser)
    },
    showLine() {
      if (ingame.isInIntlBrowser && getSys().name?.toLowerCase() === 'ios') return false;
      const browser = getSpecialBrowserType();
      if (!isInIntlBrowser && ['kakao'].includes(browser) && getSys().name?.toLowerCase() === 'android') return false;
      return true
    },
    showFacebook() {
      const browser = getSpecialBrowserType();
      if (!isInIntlBrowser && ['kakao'].includes(browser) && getSys().name?.toLowerCase() === 'android') return false;
      return true;
    }
  },
  watch: {
    language: {
     handler(lang) {
        window.setLocal(lang);
        const divs = languageArr.map(lang => {
          const divDom = window.$(`<li data="${lang.value}">${lang.label}</a>`);
          divDom.on('click', this.setLanguage)
          return divDom;
        })
        window.$('.top_language .top_lan_list').empty().append(divs)
        const langData = languageArr.find((langInfo) => langInfo.value === lang);
        window.$('.top_now_lan').html(langData?.label);
      },
      immediate: true,
    },
    areaId(val) {
      if (!val || val === '0' || !checkLogin()) return;
      this.roleList = [];
      const role = this.areaRoleMap.get(val);
      if (role) {
        this.roleList = role;
        this.buildRoleSelect();
        return;
      }
      this.loading = true;
      this.buildRoleSelect();
      getRoleInfo({area_id: val }).then((res) => {
        if (!res || res.code !== 0) return;
        const { data } = res;
        if (!data.role_list) return;
        const { role_list: get_role_info = [] } = data;
        this.areaRoleMap.set(val, get_role_info);
        // 异步 可能 areaId已改变
        if (val !== this.areaId) {
          return
        }
        this.roleList = get_role_info;
        if (get_role_info.length) {
          this.roleId = get_role_info[0].role_id;
        }
      }).finally(() => {
        this.loading = false;
        this.buildRoleSelect();
      })
    },
    // roleName: {
    //   handler(val) {
    //     if (!this.isLogin) {
    //       window.$(".top_user_name").hide();
    //       return;
    //     }
    //     if (!val || !this.choosed) {
    //     window.$(".top_user_name").hide();
    //     return;
    //     };
    //     window.$(".top_user_name").show();
    //     window.$(".top_user_name").text(val);
    //   },
    //  immediate: true,
    // },
    selectedName: {
      handler(val) {
        if (!this.isLogin) {
          window.$(".top_user_name").hide();
          window.$(".top_user_hd").show();
          return;
        }
        if (!val || !this.choosed) {
          window.$(".top_user_name").hide();
          window.$(".top_user_hd").show();
          return;
        };
        window.$(".top_user_hd").hide();
        window.$(".top_user_name").show();
        window.$(".top_user_name").text(val);
      },
     immediate: true,
    },
    showMask: {
      handler(val) {
        const mask = window.$(".livingLoading");
        if (!val) {
          if (!mask.length) return;
          mask.addClass('unshow')
          return;
        }
        if (mask.length) {
          mask.removeClass('unshow');
          return;
        }
        const maskDom = window.$('<div class="livingLoading"></div>');
        maskDom.on("click", this.clcikMask)
        maskDom.appendTo(window.$("body"))
      },
      immediate: true,
    },
  },
  beforeCreate() {
  },
  async created(){
    (window as any).checkCanCook = this.checkCanCook;
    (window as any).clickDishReward = this.clickDishReward;
    this.areaRoleMap = new Map();
    await Login.init()
    this.isLogin = checkLogin()
    await initServetime();
    await this.init();
    this.addMask();
  },
  mounted(){
    window.$('.top_user_hd').on('click', this.clickLogin)
    if (isInIntlBrowser) {
      // window.$(".top_loginout").replaceWith("<span></span>");
      // var style = document.createElement('style');
      // // 设置新<style>元素的内容为修改后的::after伪元素的CSS规则
      // style.innerHTML = '.top_login_username::after { display: none; }';
      // // 将新的<style>元素添加到文档的<head>中
      // document.head.appendChild(style);
      window.$(".top_user_hd").css("display", "none");
      window.$(".top_user_name").css('display','block');
      window.$(".top_dl_change").html("<span></span>");
      
    }
    window.$(".top_dl_change .qh").on("click", this.showAreaSelect);
    window.$(".top_loginout").on("click", this.logout)
    window.$(".top_lang_list li").on("click", this.setLanguage)
    window.$("#d4 .dia_btnbox a").on("click", this.submitRole)
    window.$('.p1_start_btn').on('click', this.clickStart)
    window.$('.p2_sure_btn').on('click', this.clickChoose)
    window.$('.p2btn1').on('click', this.slotAgain)
    window.$('.p2btn2').on('click', this.preShare)
    window.$('.p3btn1').on('click', this.clickPrepareShare)
    window.$(`.top_sharebox .twitter`).on('click', this.getOpenTwitterLink)
    window.$(`.top_sharebox .facebook`).on('click', this.getOpenFacebookLink)

    // 上报 
    window.$('.p2_cd_btn.light').on('click', this.clickLeftFood)
    window.$('.p1_next_btn').on('click', this.clickChooseNikke)
    window.$('.p3_chosebtn').on('click', 'a', this.clickChooseDish)
    window.$('.p3_cbtn2').on('click', "a",  this.clickChooseDish)
  
    this.appendShareChannel();

    (window as any).checkLogin = (openLogin = false) => {
      const isLogin = this.isLogin && this.choosed;
      if (!this.isLogin) {
        if (openLogin) {
          this.checkLogin();
        }
      } else if (!this.choosed) {
        this.trigerAreaSelect();
      }
      return isLogin;
    }

  },
  methods: {
    async init() {
      if (checkLogin()){
        // 登录了， 异步获取 绑定区服信息
        await this.getLoginedInitInfo();
        if (isInIntlBrowser && this.firstBinding) {
          // 游戏内首次绑定弹出奖励框
          setTimeout(() => {
            (window as any).showDialog('d5');
          }, 300);
          this.firstBinding = false;
        }
      }
    },
    // 活动过期蒙层
    addMask() {
      if (window.serverTime < startTimestamp || window.serverTime > endTimestap) {
        this.showMask = true;
      }
    },
    clcikMask() {
      if (window.serverTime < startTimestamp) {
        this.showMessage(this.$t('FlowHasNotBegin'))
        return;
      }
      if (window.serverTime > endTimestap) {
        this.showMessage(this.$t('FlowHasEnd'))
        return;
      }
      this.showMask = false;
    },
    showMessage(text: string) {
      window.showTips(text);
    },
    setLanguageDialog,
    setLanguage(event: Event) {
      event.stopPropagation();
      const lang = window.$(event.target).attr("data-lan").toLowerCase();
     
      console.log('setLanguage', lang);
      this.language = lang;
      closeLangDialog()
      // 切换语言跳链接
      switchLang(lang);
    },
    async submitRole(){
      if (this.loading) return;
      if (!checkLogin()) {
        this.showMessage(this.$t("no_role_found"))
        return;
      }
      if (!this.roleId || this.roleId === '0' || !this.areaId || this.areaId === '0') {
        this.showMessage(this.$t("no_role_found"))
        return;
      }
      if (!this.roleName) {
        this.showMessage(this.$t("no_role_found"))
        return;
      }
      this.loading = true;
      try {
        const res = await saveRoleInfo({
          area_id: this.areaId,
          role_id: this.roleId,
        });
        if(res && res.code === 601009) {
          window.location.reload()
          return
        }
        if (res && res.code == 0) {
          window.$('#layerServer').fadeOut(500);
          this.choosed = true;
          this.selectedRoleId = this.roleId;
          this.selectedRoleList = [].concat(this.roleList);
          this.getLoginedInitInfo();
          this.trigerAreaSelect();
          // 首次绑定弹出奖励框
          if (this.firstBinding) {
            setTimeout(() => {
              (window as any).showDialog('d5');
            }, 300);
            this.firstBinding = false;
          }
        }
      } finally {
        this.loading = false;
      }
    },
    showAreaSelect() {
      if (this.isLogin) {
        // this.areaId = `${this.serverList[0].id}`;
        this.buildServerSelect();
        this.changePage("d4");
      }
    },
    async trigerAreaSelect(){
      if (this.choosed) {
        window.closeDialog();
        return;
      }
      // this.areaId = `${this.serverList[0].id}`;
      this.areaId = this.choosed ? `${this.serverList[0].id}` : 0;
      this.buildServerSelect();
      this.changePage("d4");
    },
    buildServerSelect() {
      const divs = ProdServerMap.map(item => {
        const divDom = window.$(`<li value=${item.id}>${item.name}</li>`);
        divDom.on('click', this.handleSeverSelect)
        return divDom;
      })
      window.$('.dia_option_list').empty().append(divs);
      const serverInfo = ProdServerMap.find((item) => item.id.toString() === this.areaId);
      if (!serverInfo) return;
      window.$('.dia_select p').empty().text(serverInfo.name);
    },
    handleSeverSelect (event: Event){
      const value = window.$(event.target).val();
      console.log('handleSeverSelect', event, value);
      this.areaId = value;
    },
    buildRoleSelect() {
      let text = "";
      if (this.loading) {
        text = this.$t('loading');
      } else {
        text = this.roleList.map((role: RoleInfo) => {
          return role.role_name
        }).join('');
      }

      if (!text) {
        text = this.$t('NoRoleInfo');
      }
      
      window.$('.dia_select_name').text(text);
    },
    handleRoleSelect (event: Event){
      const value = window.$(event.target).children('option:selected').val();
      this.roleId = value;
    },
    async clickLogin(e:any){
      e.preventDefault();
      e.stopPropagation();
      if (!await this.checkLogin()) {
        if (this.isLogin && !this.choosed) {
          (window as any).$('.top_dl_change').show();
          (window as any).$(".top_lang_list").hide();
        }
        return;
      } else {
        // show
        // (window as any).$('.top_dl_change').show();
        // (window as any).$(".top_lang_list").hide()
      }
    },
    logout() {
      if (isInIntlBrowser) return;
      Login.logout();
      window.location.reload()
    },
    async checkLogin() {
      if (this.isLogin && this.choosed) return true;
      if (!this.isLogin){
        // 打开登录框
        Login.login(this.language).then(async res => {
          if (res && (res.ret as any) === 0) {
            this.isLogin = true;
            await this.getLoginedInitInfo();
          }
        });
        return false;
      }
      if (!this.choosed) {
        // this.trigerAreaSelect()
        return false;
      }
      return this.isLogin && this.choosed;
    },
    async getLoginedInitInfo() {
      if (!this.isLogin) return;
      await this.getLoginedInfo();
      
      this.trigerAreaSelect();
    },
    clickLogout(event: Event){
      event.stopPropagation();
      window.$('.loginout_box').show();
    },
    async dynamicShare(){
      if (this.isLoading) {
        return;
      }
      // (window as any).gm.loading()
      // 港澳台 不使用分享服务， 无法部署资源， 修改html查看效果
      this.isLoading = true;
      this.dynamicShareResult = null;
      this.downLoadImag = null;
      const dish = this.getChooseShareParam();
      const uid = `${this.language}_${this.areaId}_${this.roleId}_${dish}_${dynamicPath}`;
      // var template = document.getElementById("certificateBox");
      // const imgCanvas = await (window as any).html2canvas(template!, {
      //   dpi:200,
      //   scale:2,
      //   useCORS: true, //（图片跨域相关）
      //   allowTaint: false, //允许跨域（图片跨域相关）
      // })
      // const shareImg = imgCanvas.toDataURL('image/jpeg');
      const shareImg = (document.querySelector('#certificateBox img') as HTMLImageElement).src;
      this.downLoadImag = shareImg;
      // const shareImg2 = await this.getBase64Image('#certificateBox', { scale: 1 })
      // 港澳台 不使用分享服务， 无法部署资源， 修改html查看效果
      if (isHtm) {
        this.dynamicShareResult = {
          // 港澳台分享地址， 由dynamicShareResult覆盖 TODO
          share_url: htmUrl,
        };
        this.isLoading = false;
        return
      };
      try {
        let t1 = new Date().getTime();
        const cmsLang = CMSLanguage[this.language as keyof typeof CMSLanguage];
        const result = await dynamicShare({
          file: dataURLtoFile(shareImg, `${uid}.jpg`).file,
          uid,
          url_querys: new URLSearchParams({ language: cmsLang }),
        })
        this.dynamicShareResult = result;
      } catch (e){
        this.showMessage(this.$t("serverError"))
      } finally{
        this.isLoading = false;
      }
    },
    async dynamicSquareShare(){
      try {
        this.kakaoShareResult = null;
        window.$('.loading').show();
        const dish = this.getChooseShareParam();
        const cmsLang = CMSLanguage[this.language as keyof typeof CMSLanguage];
        const uid = `kakao_${this.language}_${this.areaId}_${this.roleId}_${dish}_${dynamicPath}`;
        const commonImg = await imageToBase64('./ossweb-img/share_kakao.jpg')
        const result = await dynamicShare({
          file: dataURLtoFile(commonImg as string, `${uid}.jpg`).file,
          uid,
          url_querys: new URLSearchParams({ language: cmsLang }),
        })
        this.kakaoShareResult = result;
      } finally {}
    },
    // 重新抽取
    slotAgain() {
      reportTlog({
        action: "nikkebunny_read_again_btn",
        sub_action: "cm_click",
        ext_content: {
          server_id: this.areaId,
          user_role_id: this.selectedRoleId,
          role_id: this.getDish(),
        }
      })
    },
    // 提前生成分享链接
    preShare() {
      if ((window as any).animatRunning) {
        // 还没赋值
        return;
      }
      reportTlog({
        action: "nikkebunny_confirm_btn",
        sub_action: "cm_click",
        ext_content: {
          server_id: this.areaId,
          user_role_id: this.selectedRoleId,
          role_id: this.getDish(),
        }
      })
      this.shareLoading = 1;
      (window as any).showShare('share_ele', '.share_dia_in', 'd_share_img', () => {
        setTimeout(() => {
          let start = new Date().getTime();
          const sharePromise = [this.dynamicShare()];
          if (this.language === 'ko' && this.showKakao) {
            // 韩服kakao分享特殊处理
            sharePromise.push(this.dynamicSquareShare());
          }
          Promise.all(sharePromise).then(() => {
            if (this.shareLoading == 2) {
              (window as any).showDialog('d2');
              (window as any).hideGloading();
            }
            this.shareLoading = 0;
            console.log('use api:',new Date().getTime() - start)
          })
        }, 0);
      })
      const slotResult = (window as any).slotMachineResult || [];
      reportTlog({
        action: "nikkebunny_result_page",
        sub_action: "cm_vshow",
        ext_content: {
          server_id: this.areaId,
          user_role_id: this.selectedRoleId,
          role_id: this.getDish(),
          action: slotResult[0] || 1,
          person: slotResult[1] || 1,
          location: slotResult[2] || 1,
        }
      })
    },
    clickPrepareShare() {
      (window as any).showGloading();
      if (this.shareLoading === 1) {
        this.shareLoading = 2;
      } else {
        (window as any).showDialog('d2');
        (window as any).hideGloading();
      }
      reportTlog({
        action: "nikkebunny_share_btn",
        sub_action: "cm_click",
        ext_content: {
          role_id: this.getDish(),
          user_role_id: this.selectedRoleId,
          server_id: this.areaId
        }
      })
      return;
      // (window as any).showShare('share_ele', '.share_dia_in', 'd_share_img', () => {
      //   setTimeout(() => {
      //     let start = new Date().getTime();
      //     this.dynamicShare().then(() => {
      //       (window as any).showDialog('d2');
      //       (window as any).hideGloading();
      //       console.log('use api:',new Date().getTime() - start)
      //     })
      //   }, 0);
      // })
      // reportTlog({
      //   action: "valentinefood_share_btn",
      //   sub_action: "cm_click",
      // })
    },
    async share(channel: string) {
      // if (channel === 'kakao' && this.language !== 'zh') {
      //   await this.dynamicSquareShare();
      // } else {
      //   await this.dynamicShare()
      // }
      if (this.isLoading || !this.dynamicShareResult) {
        this.showMessage(this.$t("laodingPic"))
        return;
      }
      const res = await submitShare();
      if (!res || res.code !== 0) return;
      if (!!(res.data as any).first_share) {
        // 首次分享展示弹窗
        setTimeout(() => {
          (window as any).showDialog('d5');
        }, 300);
      }
      // const dish = this.getDish();
      // const shareContent = this.$t(`shareContent${dish}`)
      const shareContent = (window as any).getShareContent();
      const shareResult = channel === 'kakao' ? this.kakaoShareResult : this.dynamicShareResult;
      try{
        await share({
          ...shareResult,
          app_id: fb_app_id,
          title: shareContent,
          text: shareContent,
          hashtag: "#NIKKE",
          channel,
        });
      } catch(error) {
        console.log('share error', error)
      }
      reportTlog({
        action: "nikkebunny_chanel_share_btn",
        sub_action: "cm_click",
        ext_content: {
          channel_name: channel,
          server_id: this.areaId,
          user_role_id: this.selectedRoleId,
          type: 'main',
          dst_url: shareResult.share_url,
          role_id: this.getDish()
        }
      })
    },
    async getBase64Image(selector: string, options = { scale: 2 }){
      const dom = document.querySelector(selector) as HTMLElement;
      if (!dom) return;
      const uri = await domToBase64(dom, { ...options })
      return uri; // 获取生成的图片的url
    },
    async getBase64ImageByDom(dom: HTMLElement, options = { scale: 2 }){
      if (!dom) return;
      const uri = await domToBase64(dom, { ...options })
      return uri; // 获取生成的图片的url
    },
    downloadImage() {
      reportTlog({
        action: "nikkebunny_download_pic_btn",
        sub_action: "cm_click",
        ext_content: {
          server_id: this.areaId,
          user_role_id: this.selectedRoleId,
          role_id: this.getDish()
        }
      })
      const browser = getSpecialBrowserType();
      // android 无法保存图片
      if (ingame.isInIntlBrowser && getSys().name?.toLowerCase() === 'android') {
        if (this.loading || !this.downLoadImag) {
          this.showMessage(this.$t('laodingPic'))
          return;
        }
        // 【安卓】繁中 游戏内点击游戏下载按钮出现闪退
        // if (isHtm) {
          this.showMessage(this.$t("open_in_browser"));
        //   return
        // }
        // ingame.openInBrowser(this.downloadUrl || this.downLoadImag);
      } else if (['facebook', 'line', 'ins'].includes(browser) && getSys().name?.toLowerCase() === 'android') {
        // 提示
        this.showMessage(this.$t("open_in_browser"));
        return;
        // window.open(this.dynamicShareResult.image_url, '_blank');
      } else {
        if (!this.downLoadImag) {
          this.showMessage(this.$t('laodingPic'))
          return;
        }
        download({
          base64: this.downLoadImag,
          // TODO
          filename: this.$t('title') + '.jpg',
        });
      }
    },
    async clickStart(event: Event) {
      reportTlog({
        action: "nikkebunny_main_role_btn",
        sub_action: "cm_click",
        ext_content: {
          server_id: this.areaId,
          user_role_id: this.selectedRoleId,
          role_id: this.getDish()
        }
      })
    },
    async getLoginedInfo() {
      const res = await getLoginedInitInfo()
      if (!res || res.code !== 0) return;
      const { data } = res;
      const { get_saved_role_info, first_binding } = data;
      this.choosed = !!get_saved_role_info;
      if (typeof first_binding === 'undefined') {
        // 后台接口有可能不返回该字段，这时候对比get_saved_role_info来判断
        this.firstBinding = !!!get_saved_role_info;
      } else {
        this.firstBinding = !!first_binding;
      }
      if (get_saved_role_info) {
        const { area_id, role_id }  = get_saved_role_info || {};
        this.roleList = [get_saved_role_info];
        this.selectedRoleList = [get_saved_role_info];
        this.areaId = area_id;
        this.roleId = role_id;
        this.selectedRoleId = role_id;
        this.areaRoleMap.set(area_id, [get_saved_role_info]);
      } else {
        this.roleList = [];
        this.areaId = 0;
        this.roleId = 0;
      }
    },
    getOpenTwitterLink(e: Event) {
      e.preventDefault();
      interface LinkMap {
        [key: string]: {
          pc: string;
          mobile: string;
        };
      }
      const linkMap: LinkMap = {
        ja: {
          pc: 'https://twitter.com/NIKKE_japan',
          mobile: 'https://twitter.com/NIKKE_japan',
        },
        ko: {
          pc: 'https://twitter.com/NIKKE_kr',
          mobile: 'https://twitter.com/NIKKE_kr',
        },
        en: {
          pc: 'https://twitter.com/NIKKE_en',
          mobile: 'https://twitter.com/NIKKE_en',
        },
        zh: {
          pc: 'https://twitter.com/NIKKE_en',
          mobile: 'https://twitter.com/NIKKE_en',
        },
      }
      const link = linkMap[getLang()];
      if (!link) return window.open('https://twitter.com/NIKKE_en', '_blank');
      if (isMobile()) return window.open(link.mobile, '_blank');
      return window.open(link.pc, '_blank');
    },
    getOpenFacebookLink(e: Event) {
      e.preventDefault();
      interface LinkMap {
        [key: string]: {
          pc: string;
          mobile: string;
        };
      }
      const linkMap: LinkMap = {
        ja: {
          pc: 'https://facebook.com/nikke.global',
          mobile: 'https://facebook.com/nikke.global',
        },
        ko: {
          pc: 'https://www.facebook.com/nikke.kr.official/',
          mobile: 'https://www.facebook.com/nikke.kr.official/',
        },
        en: {
          pc: 'https://facebook.com/nikke.global',
          mobile: 'https://facebook.com/nikke.global',
        },
        zh: {
          pc: 'https://www.facebook.com/TW.NIKKE',
          mobile: 'https://www.facebook.com/TW.NIKKE',
        },
      }
      const link = linkMap[getLang()];
      if (!link) return window.open('https://twitter.com/NIKKE_en', '_blank');
      if (isMobile()) return window.open(link.mobile, '_blank');
      return window.open(link.pc, '_blank');
    },
    getOpenNarLink(e: Event){
      e.preventDefault();
      return window.open('https://game.naver.com/lounge/nikke/board/11/', '_blank');
    },
    toPolicy(type: 'cookie' | 'privacy' = 'cookie') {
      const map = {
        cookie: this.$t('cookiesLink'),
        privacy: this.$t('privacyLink'),
      };
      const url = map[type]
      window.open(url, '_blank');
    },
    selectArea(event: any) {
      const { value } = event.target;
      if (!value) return;
      this.areaId = String(value);
    },
    selectRole(event: any) {
      const { value } = event.target;
      if (!value) return;
      this.roleId = String(value);
    },
    appendShareChannel() {
      const shareChannelMap = {
        en: ['twitter', 'facebook'],
        th: ['twitter', 'facebook', 'line'],
        ja: ['twitter', 'line'],
        ko: ['twitter', 'kakao'],
        zh: ['twitter','facebook', 'line'],
      };
      const shareChannel = shareChannelMap[this.language as keyof typeof shareChannelMap];
      const divs = shareChannel.map(channel => {
        if (channel === 'kakao' && !this.showKakao) return;
        if (channel === 'line' && !this.showLine) return;
        if (channel === 'facebook' && !this.showFacebook) return;

        const nameMap = {
          twitter: 'twitter',
          facebook: 'facebook',
          line: 'line',
          kakao: 'kakao',
        }
        const name = nameMap[channel as keyof typeof nameMap];
        const divDom = window.$(`<a href="javascript:;"  target="_blank" class="${name}_icon" title=""></a>`);
        divDom.on('click', (e: Event) => {
          e.preventDefault();
          console.log('click', channel);
          this.share(channel);
        })
        return divDom;
      })
      const download = window.$(`<a class="download_icon" title="" target="_blank"></a>`)
      download.on("click", this.downloadImage);
      window.$('.share_dia_btn').empty().append(divs).append(download);
    },
    changePage(id: string) {
      (window as any).showDialog(id);
      // (window as any).TGDialogS(id);
    },
    getDish() {
      return ((window as any).roleChoose || 0) + 1;
    },
    getChooseShareParam() {
      // 分享图片参数，一共4个动态内容，选择人物，3个动态文案
      const role = (window as any).roleChoose || 1;
      const content = (window as any).slotMachineResult || [];
      return [role].concat(content).join('_');
    },
    clickChooseNikke() {
      // const choseNum = ((window as any).roleChoose || 0) + 1;
      // const nameDOm = window.$(`.p2_m${choseNum + 1} span`);
      // const name = nameDOm.text() || "";
      reportTlog({
        action: "nikkebunny_read_me_btn",
        sub_action: "cm_click",
        ext_content: {
          server_id: this.areaId,
          user_role_id: this.selectedRoleId,
          role_id: this.getDish()
        }
      })
    }
  },
});
